<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/investidor/due-diligences/${$route.params.idDueDiligence}/startups`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para listagem das
              startups</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-4 order-lg-1">
          <card shadow type="secondary" class="text-center">
            <div class="card-profile-image">
              <img
                v-if="startup.logo"
                :src="startup.logo.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 py-0">
              <h2 class="card-title text-orange mb-1">
                {{ startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                  {{ startup.state || "..." }}
                </div>
              </div>
              <p class="ml-2 text-sm mt-3">
                <i class="fas fa-quote-left mr-1"></i
                >{{ startup.one_sentence_pitch
                }}<i class="fas fa-quote-right ml-1"></i>
              </p>
              <hr class="my-4" />
              <div v-if="startup.subscription" class="text-left">
                <div>
                  <h6 class="heading-small text-muted mb-4">Sobre a startup</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Pricipal setor de
                    atuação:
                    <span class="text-muted">
                      {{ startup.sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Data de fundação:
                    <span class="text-muted">
                      {{ formatDate(startup.foundation) }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Incubada:
                    <span class="text-muted">
                      {{
                        startup.subscription.startup_is_incubated
                          ? "Sim"
                          : "Não"
                      }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Responsável:
                    <span class="text-muted">
                      {{ startup.subscription.responsible_name }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Telefone do responsável:
                    <span class="text-muted">
                      {{ startup.subscription.responsible_phone }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> E-mail do responsável:
                    <span class="text-muted">
                      {{ startup.subscription.responsible_email }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i>Qual é o problema ou
                    necessidade específica dos clientes que sua empresa busca
                    resolver?:
                    <span class="text-muted">
                      {{ startup.subscription.product_market_problem }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Em qual mercado principal
                    sua startup pretende atuar?
                    <span class="text-muted">
                      {{ startup.bussiness_strategy }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual estágio a startup
                    está atualmente?
                    <span class="text-muted">
                      {{ startup.stage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Quais são os desafios
                    mais significativos que sua empresa enfrenta atualmente?
                    <span class="text-muted">
                      {{ startup.subscription.startup_problem }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> De que forma você espera
                    que a Stars possa auxiliar a sua startup?
                    <span class="text-muted">
                      {{ startup.subscription.how_can_stars_help }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Número de sócios:
                    <span class="text-muted">
                      {{
                        startup.subscription.startup_equity &&
                        startup.subscription.startup_equity.length > 0
                          ? startup.subscription.startup_equity.length
                          : startup.subscription.startup_number_partners
                      }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Número de colaboradores:
                    <span class="text-muted">
                      {{ startup.subscription.startup_number_employees }}
                    </span>
                  </p>
                  <div
                    v-if="
                      startup.subscription.startup_equity &&
                      startup.subscription.startup_equity.length
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Estrutura de equity:
                    </p>
                    <ul class="description">
                      <li
                        v-for="(socio, index) in startup.subscription
                          .startup_equity"
                        :key="`socio_${index}`"
                      >
                        {{ socio }}
                      </li>
                    </ul>
                  </div>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> A startup já participou
                    da seleção em outro Batch da Stars? Caso sim, quando?
                    <span class="text-muted">
                      {{ startup.subscription.already_participated_batch }}
                    </span>
                  </p>
                </div>
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Negócio</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Tecnologia de
                    desenvolvimento próprio:
                    <span class="text-muted">
                      {{
                        startup.subscription.product_own_technology
                          ? "Sim"
                          : "Não"
                      }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Mercardo alvo:
                    <span class="text-muted">
                      {{ startup.subscription.product_target_market }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Vantagem competitiva:
                    <span class="text-muted">
                      {{ startup.subscription.product_competitive_advantage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Estratégia de negócio:
                    <span class="text-muted">
                      {{ startup.subscription.product_bussiness_strategy }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual foi o valor total do
                    faturamento no último trimestre em reais?
                    <span class="text-muted">
                      {{ startup.subscription.last_quarters_revenue }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual o tamanho de
                    mercado? (opcional)
                    <span class="text-muted">
                      {{ startup.subscription.product_market_cap }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Quantos clientes ativos a
                    startup possui atualmente?
                    <span class="text-muted">
                      {{ startup.subscription.active_clients }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual o valor de
                    investimento que a startup busca?
                    <span class="text-muted">
                      {{ startup.subscription.investment_sought }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Qual o percentual de
                    equity oferecido? (máximo de 100%)
                    <span class="text-muted">
                      {{ startup.subscription.equity_offered }}%
                    </span>
                  </p>
                  <p class="text-sm mb-1">
                    <i class="fas fa-arrow-right"></i> Mais informações:
                  </p>
                  <ul class="description mb-0">
                    {{
                      getWebsiteUrl()
                    }}
                  </ul>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Avaliação técnica -
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h6 class="heading-small text-muted mb-4">
                <i class="fab fa-youtube mr-1"></i> Pitch vídeo
              </h6>
              <div class="video-wrap">
                <div class="video-container">
                  <iframe
                    v-if="startup.subscription"
                    :src="
                      getUrl(
                        startup.subscription.startup_pitch_video_youtube_id
                      )
                    "
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <div class="col">
              <div>
                <h6 class="heading-small text-muted mb-4">
                  <i class="far fa-file-pdf mr-1"></i> Pitch deck
                  <a
                    v-if="startup.subscription && startup.subscription.deck"
                    :href="startup.subscription.deck.url"
                    target="_blank"
                    class="btn btn-sm btn-primary float-right"
                  >
                    <i class="fas fa-file-download"></i> Baixar
                  </a>
                </h6>
                <div class="row mt-3">
                  <div class="col text-center">
                    <div
                      v-if="startup.subscription && startup.subscription.deck"
                    >
                      <pdf
                        style="margin: 0 auto; width: 90%; max-width: 700px"
                        ref="startupDeck"
                        :src="startup.subscription.deck.url"
                        :page="deck.page"
                        @num-pages="deck.pageCount = $event"
                        @page-loaded="deck.currentPage = $event"
                      ></pdf>
                      <div class="text-center mt-2">
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-left"
                          size="sm"
                          class="mr-0"
                          @click="previousPage()"
                          :disabled="this.deck.page <= 1"
                        ></base-button>
                        <span class="mx-3 text-sm"
                          >{{ deck.currentPage }} / {{ deck.pageCount }}</span
                        >
                        <base-button
                          :iconOnly="true"
                          icon="fa fa-chevron-right"
                          size="sm"
                          class="mr-0"
                          @click="nextPage()"
                          :disabled="this.deck.page >= this.deck.pageCount"
                        ></base-button>
                      </div>
                    </div>
                    <div v-else>
                      <badge type="info"> Pitch deck não encontrado </badge>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-4" />
              <h6 class="heading-small text-muted mb-4">
                <i class="fas fa-comment-dots mr-1"></i> Breves Considerações
                <span class="text-warning">Stars</span>
              </h6>
              <div class="ml-3 di-container-read-only">
                <quill-editor
                  v-if="startup.subscription && startup.subscription.note"
                  v-model="startup.subscription.note.considerations_stars"
                  :options="editorReadOnly"
                  disabled="disabled"
                >
                </quill-editor>
                <p v-else>N/A</p>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  name: "avaliacao",
  components: {
    pdf,
    quillEditor,
  },
  data() {
    return {
      startup: "",
      dueDiligence: "",
      error: "",
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble",
      },
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    await this.loadSubscription();
    const translatedStage = {
      concept: "Ideação",
      validation: "Validação",
      traction: "Tração",
      scale: "Escala",
      other: "Outro",
    };

    if (this.startup && this.startup.stage) {
      this.startup.stage = translatedStage[this.startup.stage] || "Outro";
    } else if (this.startup) {
      this.startup.stage = "Não informado";
    }
    loader.hide();
  },
  methods: {
    getWebsiteUrl() {
      if (
        !this.startup.subscription ||
        !this.startup.subscription.product_more_information
      ) {
        return "não informado";
      }
      const productInfo = this.startup.subscription.product_more_information;
      if (Array.isArray(productInfo)) {
        const firstItem = productInfo[0];
        if (!firstItem || firstItem === "" || firstItem === "undefined") {
          return "não informado";
        }
        return firstItem;
      }
      if (typeof productInfo === "string") {
        try {
          const parsed = JSON.parse(productInfo);
          if (parsed && parsed.link && parsed.link.trim() !== "") {
            return parsed.link;
          }
          return "não informado";
        } catch (e) {
          return productInfo && productInfo.trim() !== ""
            ? productInfo
            : "não informado";
        }
      }
      return "não informado";
    },
    async loadSubscription() {
      try {
        const {
          data: { dueDiligence, startup },
        } = await api.get(
          `/investor-due-diligences/${this.$route.params.idDueDiligence}/subscriptions/${this.$route.params.idSubscription}`
        );
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!dueDiligence || !startup) {
          this.$toasted.error("Ocorreu um erro ao recuperar a startup");
          this.$router.push("/investidor/avaliacoes");
        }
        if (!startup.logo) startup.logo = { url: defaultLogoPath };
        this.dueDiligence = dueDiligence;
        try {
          const links = JSON.parse(
            startup.subscription.product_more_information
          );
          if (Array.isArray(links)) {
            startup.subscription.product_more_information = links
              .map((link) => (link && link.link ? link.link : ""))
              .filter((link) => link && link.trim() !== "");
          } else if (links && links.link) {
            startup.subscription.product_more_information = [links.link];
          } else {
            startup.subscription.product_more_information = [];
          }
        } catch (e) {
          startup.subscription.product_more_information =
            startup.subscription.product_more_information &&
            startup.subscription.product_more_information.trim() !== ""
              ? [startup.subscription.product_more_information]
              : [];
        }
        try {
          const socios = JSON.parse(startup.subscription.startup_equity);
          startup.subscription.startup_equity = socios.map(
            (socio) => `${socio.title}: ${socio.percentage}%`
          );
        } catch (e) {
          startup.subscription.startup_equity = [
            startup.subscription.startup_equity,
          ];
        }
        this.startup = startup;
        return;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
        this.$router.push(
          `/investidor/due-diligences/${this.$route.params.idDueDiligence}/startups`
        );
      }
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}

.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
<style>
.di-container-read-only .quill-editor .ql-container,
.di-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 13rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
